module.exports = __webpack_public_path__ + "media/images/athletes/1328-c110034f1fd74c14a93580de528a8779.png";